import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/devkrest/htdocs/devkrest.com/app/(pages)/gen-ai-development-services/ai-can-stats/page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/devkrest/htdocs/devkrest.com/app/(pages)/gen-ai-development-services/power-your-products/_section/button-section-power-your-products.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/devkrest/htdocs/devkrest.com/components/common/services-page/services-image-web-grid-section/service-image-web-grid-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/devkrest/htdocs/devkrest.com/components/common/services-page/services-ready-to-banner/ready-to-turn-reality.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/devkrest/htdocs/devkrest.com/components/common/text/bodyline-text.tsx");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/components/common/text/headline-text.tsx");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/built-different/icon-bag-case.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/built-different/icon-graphup.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/built-different/icon-notes-documents.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/built-different/icon-phone-calling.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/cards-software-solutions/ai-automation.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/cards-software-solutions/custom-software.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/cards-software-solutions/digital-transform.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/cards-software-solutions/mobile-dev.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/cards-software-solutions/product-engineering.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/cards-software-solutions/web-backend.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/check/icon-primary-check.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/check/icon-verified-check-white.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/check/icon-verified-check.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/emoji/emoji-brain.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/emoji/emoji-excited.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/emoji/emoji-flash.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/emoji/emoji-handshake.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/flag/flag-aus-icon.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/flag/flag-canada-icon.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/flag/flag-india-icon.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/flag/flag-india-img.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/flag/flag-south-africa.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/flag/flag-usa-icon.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/flag/flag-usa-img.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/industry-reach/icon-industry-banking.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/industry-reach/icon-industry-e-commerce.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/industry-reach/icon-industry-education.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/industry-reach/icon-industry-insurance.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/industry-reach/icon-industry-reach-dating.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/industry-reach/icon-industry-reach-fitness.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/industry-reach/icon-industry-reach-food.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/industry-reach/icon-industry-reach-health.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/industry-reach/icon-industry-reach-social.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/industry-reach/icon-industry-real-estate.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/industry-reach/icon-industry-transportation.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/industry-reach/icon-industry-travel.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/our-core-beleifs-card/icon-core-beleifs-devk-principle-card-diverse-perspectives.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/our-core-beleifs-card/icon-core-beleifs-devk-principle-card-growth-that-feels.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/our-core-beleifs-card/icon-core-beleifs-devk-principle-card-ownership.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/our-core-beleifs-card/icon-core-beleifs-devk-principle-card-team-first-thinking.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/perks-benefits/icon-perks-benefits-bonus-rewards.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/perks-benefits/icon-perks-benefits-career-growth.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/perks-benefits/icon-perks-benefits-competitive-salary.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/perks-benefits/icon-perks-benefits-evening-snacks.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/perks-benefits/icon-perks-benefits-flexible-time.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/perks-benefits/icon-perks-benefits-joyful-events.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/perks-benefits/icon-perks-benefits-learning-courses.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/perks-benefits/icon-perks-benefits-no-boad.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/social/cookie.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/social/dribbble-logo.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/social/facebook-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/social/instagram-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/social/linkedin-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/social/x-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/social/youtube-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/stats-trusted-businesses/icon-assets-managed-trusted-businesses.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/stats-trusted-businesses/icon-countries-served-trusted-businesses.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/stats-trusted-businesses/icon-project-delivered-trusted-businesses.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/stats-trusted-businesses/icon-repeat-clients-trusted-businesses.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/tech-stack/aws-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/tech-stack/azure-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/tech-stack/expo-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/tech-stack/flutter-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/tech-stack/googlecloud-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/tech-stack/mongodb-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/tech-stack/mysql-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/tech-stack/nextjs-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/tech-stack/nodejs-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/tech-stack/opnai-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/tech-stack/postgresql-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/icon/tech-stack/reactjs-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/about-us/about-us.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/about-us/light-dev-bg.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/about-us/why-choose-us.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/ai-engineering-squad/claude.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/ai-engineering-squad/design.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/ai-engineering-squad/engineering.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/ai-engineering-squad/gemini.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/ai-engineering-squad/github copilot.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/ai-engineering-squad/grok.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/ai-engineering-squad/management.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/ai-engineering-squad/midjourney.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/ai-engineering-squad/openai.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/ai-engineering-squad/replit.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/ai-engineering-squad/windsurf.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/badge-trusted-businesses/badge-top-related-talent.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/badge-trusted-businesses/badge-top-tech-team.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/blog/authors/faisaluddin.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/blog/authors/priya-patel.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/blog/authors/raj-sharma.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/blog/devops-practices.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/blog/microservices-architecture.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/blog/related-1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/blog/related-2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/blog/software-product-discovery.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/bottom-banner-img/banner-vector-svg.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/build-smart-card-img/ai-based-card-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/build-smart-card-img/fast-track-card-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/build-smart-card-img/human-centered-card-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/careers/bg-join-the-team-careers.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/careers/icon-quote-blue.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/careers/img-mission-rating-section-join-team.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ai-based-insurance-plan-finder-solution/agent.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ai-based-insurance-plan-finder-solution/cozmo-plan-tool-cover.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ai-based-insurance-plan-finder-solution/hero-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ai-based-insurance-plan-finder-solution/home.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ai-based-insurance-plan-finder-solution/lakhan.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ai-based-insurance-plan-finder-solution/screenshot-filter.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ai-based-insurance-plan-finder-solution/submit-policy-1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ai-based-insurance-plan-finder-solution/submit-policy-2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ai-based-insurance-plan-finder-solution/update-lead.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/case-studies-bg.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/cta-bg.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-crm-health-insurance/agent.jpg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-crm-health-insurance/cover.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-crm-health-insurance/cozmo-about-us.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-crm-health-insurance/hero_mockup.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/bg-why-we-built-platform-signit-app.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/icon-communication-success-signit-app-ful-transparency.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/icon-communication-success-signit-app-no-surprises.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/icon-communication-success-signit-app-problems-solved.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/icon-communication-success-signit-app-weekly-deep-dives.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-admin-panel-signit-app-dashboard.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-admin-panel-signit-app-documents.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-admin-panel-signit-app-envelops.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-admin-panel-signit-app-templates.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-case-study-signit-cover.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-communication-success-signit-app-auth-home-setup.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-communication-success-signit-app-daily-work-update.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-core-features-snapshot-signit-app-audit-trail-compliance.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-core-features-snapshot-signit-app-built-fit-any-crm.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-core-features-snapshot-signit-app-custom-templates.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-core-features-snapshot-signit-app-document-envelops.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-core-features-snapshot-signit-app-encrypted-sign-platform.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-core-features-snapshot-signit-app-multi-signers.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-customer-panel-signit-app.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-more-information-signit-app-project-info.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-why-we-built-platform-signit-app-completed-card.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-why-we-built-platform-signit-app-pending-card.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/img-why-we-built-platform-signit-app-steve-fehr.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/logo-why-we-built-platform-signit-app-cost-efficiency.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/logo-why-we-built-platform-signit-app-deeper-system-integration.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/logo-why-we-built-platform-signit-app-performance-at-high-volume.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/logo-why-we-built-platform-signit-app-workflow-control.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/logo-why-we-built-platform-signit-app.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/signit-case-study-hero-add-sign-mockup.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/signit-case-study-hero-case-study-mockup.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/signit-case-study-hero-side-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/signit-case-study-hero-sign-mockup.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/signit-case-study-hero-template-name-mockup.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/signit-case-study-hero-total-doc-mockup.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/custom-digital-signing-platform/signit-logo.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/daily-status-updates.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/agentbgimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/agentimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/cashbenifitimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/chatimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/discovermatterimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/downarrowimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/enrollhealthheroimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/enrollhealthlogo.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/enrollindentitylogo.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/enrolltimelineimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/everydaycareimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/ImgCaseStudyEnrollHealthCover.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/marketsizeimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/oldwebsiteimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/policysoldimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/shopindividualimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/shorttermimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/smarterchoiceimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/smarthelathplanimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/teammember1image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/teammember2image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/teammember3image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/timecunsumechartimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/userbgimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/userguidanceimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/enroll-health/userimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/chargeaway_bg.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/chargeaway-cover.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/chargeaway-dark-bg.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/chargeaway-feature-cover.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/chargeaway-hero-cover.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/design/Sticky note-1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/design/Sticky note-2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/design/Sticky note-3.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/design/Sticky note.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/dev/Sticky note-1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/dev/Sticky note-2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/dev/Sticky note-3.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/dev/Sticky note-4.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/launch/Sticky note-1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/launch/Sticky note-2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/launch/Sticky note-3.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/launch/Sticky note-4.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/testing/Sticky note-1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/testing/Sticky note-2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/testing/Sticky note-3.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/ev-charging-solution/testing/Sticky note-4.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/icon-mycasa-friends-our-role-design.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/icon-mycasa-friends-our-role-development.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/icon-mycasa-friends-our-role-research.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/icon-mycasa-friends-our-role-testing.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-case-study-mycasa-friends-cover.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-final-product-admin-panel.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-final-product-chats-booking.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-final-product-event-details-menu.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-final-product-home-search-filters.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-final-product-host-panel.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-final-product-other-screens.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-final-product-payment.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-final-product-splash-auth.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-our-role-bg.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-our-role-side-card.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-previous-app.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-top-features-chat-before-book.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-top-features-hosts-made.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-top-features-one-dashboard.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-top-features-simple-browse-events-near.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-top-features-simple-payments-users.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-total-product-admin-panel.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-total-product-host-panel.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-total-product-mobile-app.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-user-persona-emoji-cheers.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-user-persona-emoji-hand.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-user-persona-emoji-sad-smile.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-user-persona-emoji-target.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/img-mycasa-friends-user-persona-main.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/mycasa-friends-case-study-hero-thumbnail.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/event-hosting-solution/mycasa-friends-logo.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/about-bg-home-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/about-gdr-development-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/building-luxury-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/canela-about-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/crm-agents-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/crm-dashboard-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/crm-follow-ups-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/crm-house-visits-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/crm-leads-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/crm-revenue-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/figma-icon.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/first-old-boone-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/first-portfolio-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/flamingo-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/framer-motion-icon.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/fulltransparancygdrdevelopmenetimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/gdr-crm-logo.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/gdr-developmenet-frame-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/gdr-text-logo.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/greymon-drive-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/hero-bg-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/kanuga-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/mysql-icon.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/nextjs-icon.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/nodejs-icon.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/nosurprisegdrdevelopmentimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/old-bone-bg-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/portfolio-showcase-bg-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/postman-icon.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/premium-spotlight2-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/premiumsportlight3image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/premuim-spotlight1-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/problem-solution-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/problemssolvedgdrdevelopmentimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/reactjs-icon.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/second-old-bone-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/second-portfolio-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/solution-agenet-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/solution-bg-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/solution-chart-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/third-old-bone-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/third-portfolio-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/typescript-icon.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/washington-image.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/gdr-development/weeklydeepdivesgdrdevelopmentimage.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/add-private-routine-recur.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/add-private-routine-steps.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/add-private-routine.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/clear-skin.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/cover.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/edit-step.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/email-signup.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/final_product_1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/final_product_2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/final_product_3.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/for-all-skins.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/glowy-analytics.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/glowy-creator-listing.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/glowy-creator-stats.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/glowy-design-bg.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/glowy-hero-mockup.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/glowy-problem-bg.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/glowy-problem-mockup.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/glowy-reports.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/glowy-routine-activity.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/glowy-skinconcern.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/glowy-skintype.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/home-screen-2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/home-screen.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/incosistent-routine.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/login.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/more-screen-1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/more-screen-10.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/more-screen-11.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/more-screen-12.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/more-screen-2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/more-screen-3.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/more-screen-4.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/more-screen-5.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/more-screen-6.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/more-screen-7.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/more-screen-8.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/more-screen-9.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/skincare-cream.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/splash.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/tanvi.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/user-persona.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/wireframe-1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/wireframe-2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/skincare-routine-mobile-app/wireframe-3.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/trello-card.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/vision-ai-ml-recognition-mobile-app/add-record.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/vision-ai-ml-recognition-mobile-app/create-health-profile.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/vision-ai-ml-recognition-mobile-app/dashboard.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/vision-ai-ml-recognition-mobile-app/hero-mockup.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/vision-ai-ml-recognition-mobile-app/lower6_cover.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/vision-ai-ml-recognition-mobile-app/record-calendar.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/vision-ai-ml-recognition-mobile-app/scan-intake.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/case-studies/vision-ai-ml-recognition-mobile-app/scan-results.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/crm-development-services/bg-side-crm-development-service-hero.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/crm-development-services/img-card-crm-dev-services-ai-powered-crm.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/crm-development-services/img-card-crm-dev-services-crm-setup-customization.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/crm-development-services/img-card-crm-dev-services-data-migration-integration.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/crm-development-services/img-card-crm-dev-services-fully-custom-crm-dev.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/crm-development-services/img-card-crm-dev-services-scalable-hosting-maintenance.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/crm-development-services/img-card-crm-dev-services-workflow-automation.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/crm-development-services/img-crm-development-service-1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/crm-development-services/img-crm-development-service-2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/crm-development-services/img-side-crm-development-services.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/customer-succes/bg-customer-success-reliability-results.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/customer-succes/built-different/img-built-different-card.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/customer-succes/industry-reach/bg-industry-reach.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/customer-succes/testimonial-stats-card/img-adam-awany.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/customer-succes/testimonial-stats-card/img-cyrus-rafizadeh.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/customer-succes/testimonial-stats-card/img-dr-ross.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/easy-follow-card-img/build-sprint-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/easy-follow-card-img/design-purpose-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/easy-follow-card-img/kickoff-plan-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/easy-follow-card-img/launch-scale-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/gen-ai-development-services/bg-side-gen-ai-service-dev-hero.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/gen-ai-development-services/img-card-gen-ai-dev-ai-agents-workflow-automation.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/gen-ai-development-services/img-card-gen-ai-dev-ai-custom-llm-intergrations.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/gen-ai-development-services/img-card-gen-ai-dev-ai-powered-chatbots.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/gen-ai-development-services/img-card-gen-ai-dev-smart-ai-integrations.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/gen-ai-development-services/img-card-gen-ai-dev-text-image-gen-tools.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/gen-ai-development-services/img-card-gen-ai-dev-vision-ai-integration.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/gen-ai-development-services/img-gen-ai-service-development-1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/gen-ai-development-services/img-gen-ai-service-development-2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/gen-ai-development-services/img-side-gen-ai-service-development.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img_cards_mobile_app_services_consultation_guidance.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img_cards_mobile_app_services_CRM_apps.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img_cards_mobile_app_services_custom_app.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img_cards_mobile_app_services_ios_android.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img_cards_mobile_app_services_migration_upgrade.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img_cards_mobile_app_services_support_maintenance.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img-marquee-mobile-app-services-1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img-marquee-mobile-app-services-10.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img-marquee-mobile-app-services-11.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img-marquee-mobile-app-services-12.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img-marquee-mobile-app-services-13.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img-marquee-mobile-app-services-2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img-marquee-mobile-app-services-3.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img-marquee-mobile-app-services-4.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img-marquee-mobile-app-services-5.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img-marquee-mobile-app-services-6.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img-marquee-mobile-app-services-7.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img-marquee-mobile-app-services-8.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img-marquee-mobile-app-services-9.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img-mobile-app-services-build-app.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-mobile-app-services/img-mobile-app-services-customised-app.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_build_awesome_web_1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_build_awesome_web_2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_build_awesome_web_3.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_build_awesome_web_4.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_build_awesome_web_5.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_cards_web_development_services_backend_dev.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_cards_web_development_services_frontend_dev.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_cards_web_development_services_intergrations_testings.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_cards_web_development_services_ui_ux_designing.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_cards_web_development_services_upgradation_hosting.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_cards_web_development_services_website_migration.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_10.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_11.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_12.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_13.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_14.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_15.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_16.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_17.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_18.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_19.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_20.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_21.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_22.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_23.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_24.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_25.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_3.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_4.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_5.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_6.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_7.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_8.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/img-web-development-services/img_marquee_hero_9.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-powering-products/image-marquee-1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-powering-products/image-marquee-2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-powering-products/image-marquee-3.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-powering-products/image-marquee-4.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-powering-products/image-marquee-5.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-powering-products/image-marquee-6.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-powering-products/image-marquee-7.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-powering-products/image-marquee-8.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-vibe-at-devkrest/IMG_4938.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-vibe-at-devkrest/IMG_6115.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-vibe-at-devkrest/IMG_6124.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-vibe-at-devkrest/img-vibe-at-devkrest-1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-vibe-at-devkrest/img-vibe-at-devkrest-10.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-vibe-at-devkrest/img-vibe-at-devkrest-2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-vibe-at-devkrest/img-vibe-at-devkrest-3.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-vibe-at-devkrest/img-vibe-at-devkrest-4.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-vibe-at-devkrest/img-vibe-at-devkrest-5.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-vibe-at-devkrest/img-vibe-at-devkrest-6.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-vibe-at-devkrest/img-vibe-at-devkrest-7.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-vibe-at-devkrest/img-vibe-at-devkrest-8.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/marquee-vibe-at-devkrest/img-vibe-at-devkrest-9.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/bg-circle-open-source-landing.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/bg-custom-thumbnails-featured.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/bg-easy-to-understand-featured.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/bg-flutter-open-source-featured.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/bg-full-gesture-featured.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/bg-highly-customisable-featured.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/bg-null-safe-featured.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/bg-profiles-open-source-featured.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/bg-right-screen-open-soruce-landing.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/bg-stats-open-source-featured.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/bg-strickland-open-source-featured.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/bg-support-multiple-featured.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/bg-weekly-open-source-featured.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/icon-basketball.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/icon-built-on-collab-icon.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/icon-community-over-competition-icon.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/open-source/icon-innovation-without-limits-icon.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/powering-products-tech-stack/bg-powering-products-tech-stack.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/product-engineering/bg-side-product-engineering-hero.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/product-engineering/img-card-product-engineering-consultation.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/product-engineering/img-card-product-engineering-custom-software-development.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/product-engineering/img-card-product-engineering-mobile-development.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/product-engineering/img-card-product-engineering-mvp-development.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/product-engineering/img-card-product-engineering-ui-ux-development.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/product-engineering/img-card-product-engineering-web-development.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/product-engineering/img-product-engineering-1.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/product-engineering/img-product-engineering-2.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/product-engineering/img-side-product-engineering.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/project-showcase-tab-tech-stack/bg-vector-project-showcase-tab-tech-stack.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/project-showcase-tab-tech-stack/img-project-showcase-tabs-tech-stack-ai-custom.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/project-showcase-tab-tech-stack/img-project-showcase-tabs-tech-stack-crms.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/project-showcase-tab-tech-stack/img-project-showcase-tabs-tech-stack-mobile-apps.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/project-showcase-tab-tech-stack/img-project-showcase-tabs-tech-stack-website.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/services-component/background-services-component.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/software-solutions-card-img/ai-automation-card-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/software-solutions-card-img/custom-software-card-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/software-solutions-card-img/digital-transform-card-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/software-solutions-card-img/mobile-dev-card-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/software-solutions-card-img/product-engineering-card-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/software-solutions-card-img/web-backend-card-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/stories-devkrest-img/adam-awany-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/stories-devkrest-img/chargeaway-story.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/stories-devkrest-img/cozmo-agent-team.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/stories-devkrest-img/cozmo-robot-icon.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/stories-devkrest-img/cyrus.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/stories-devkrest-img/glowy-cover.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/stories-devkrest-img/janis.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/stories-devkrest-img/lincoln.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/stories-devkrest-img/lower-6-cover-story.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/stories-devkrest-img/puls-team-logo-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/stories-devkrest-img/robb.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/stories-devkrest-img/ryan.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/stories-devkrest-img/sasha.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/stories-devkrest-img/tanvi.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/stories-devkrest-img/vuor1-logo-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/tech-stack-bg-img/tech-stack-background.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/tech-stack-page/img-intergration-unite-all.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/testimonial/casa-friends.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/images/winning-hearts-card-img/winning-hearts-card-img.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/built-with-compliance-logo/logo-customer-success-compliance-aicpa.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/built-with-compliance-logo/logo-customer-success-compliance-gdpr.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/built-with-compliance-logo/logo-customer-success-compliance-hipaa.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/built-with-compliance-logo/logo-customer-success-compliance-pci-dss.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/built-with-compliance-logo/logo-customer-success-compliance-star-level.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/devkrest-logo/devkrest-logo-full-white.svg");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/devkrest-logo/devkrest-logo-text-white.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/devkrest-logo/logo-devkrest-rounded.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/epic-dev-logo/epic-dev-logo.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/global-businesses-logo/atmycasa.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/global-businesses-logo/Enroll-health-technology-logo.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/global-businesses-logo/enrollhealth.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/global-businesses-logo/glowy-logo.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/global-businesses-logo/health-prime-logo.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/global-businesses-logo/millennium.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/global-businesses-logo/nyxara.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/global-businesses-logo/pegasus.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/global-businesses-logo/signit.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/global-businesses-logo/vindico-pay.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/global-businesses-logo/vindico.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/global-businesses-logo/vodacom-logo.webp");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/mission-rating-section/logo-mission-rating-section-clutch.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/mission-rating-section/logo-mission-rating-section-glassdoor.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/mission-rating-section/logo-mission-rating-section-google.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/other-company-logo/clucth-logo.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/populary-used-tech-by/logo-popularly-used-by-adobe.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/populary-used-tech-by/logo-popularly-used-by-amazon.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/populary-used-tech-by/logo-popularly-used-by-google.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/populary-used-tech-by/logo-popularly-used-by-hulu.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/populary-used-tech-by/logo-popularly-used-by-meta.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/populary-used-tech-by/logo-popularly-used-by-microsoft.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/populary-used-tech-by/logo-popularly-used-by-netflix.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/populary-used-tech-by/logo-popularly-used-by-paypal.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/populary-used-tech-by/logo-popularly-used-by-twitch.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/populary-used-tech-by/logo-popularly-used-by-uber.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/populary-used-tech-by/logo-popularly-used-by-walmart.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-android.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-aws.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-azure.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-deepseek.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-devkrest.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-expo-native.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-fluter.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-gemini.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-google-cloud.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-html.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-hubspot.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-ios.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-javascript.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-nextjs.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-nodejs.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-openai.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-postgres-sql.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-react-native.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-react.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-typescript.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/tech-stack-precision-engineering/logo-precision-engineering-zapier.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/trusted-businessess/logo-clutch.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/logo/trusted-businessess/logo-google.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/system/footer/footer-work-rating-card-img/clutch-rating-img.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/system/footer/footer-work-rating-card-img/google-rating-img.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/system/footer/footer-work-rating-card-img/upwork-rating-img.png");
;
import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/public/system/logo.png");
